<template>
  <el-tooltip :disabled="isDisabled" :placement="tooltipPlacement as Placement">
    <template #content>
      <div>
        {{ tooltipText }}
      </div>
    </template>
    <dd-button
      v-bind="$attrs"
      :class="{'disabled': isDisabled }"
      class="remote-control-button"
      type="circle"
    >
      <i :class="iconClassName" class="ddi" />
    </dd-button>
  </el-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Placement } from 'element-plus'

export default defineComponent({
  name: 'RemoteControlButton',

  // el-tooltip drops attributes it doesn't use, so the parent's class and @click go on the button, which Element UI's
  // tooltip rendered as the root
  inheritAttrs: false,

  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    tooltipPlacement: {
      type: String,
      default: 'bottom',
    },
    tooltipText: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      required: true,
    },
  },

  computed: {
    iconClassName(): string {
      return `ddi-${this.iconName}`
    },
  },
})
</script>

<style lang="scss">
.remote-control-button {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-third);
  background-color: var(--color-background-header);

  &.disabled {
    pointer-events: none;
    cursor: none;
    opacity: 0.4;
  }

  &.dd-button {
    flex-shrink: 0;
    width: 32px;
    height: 32px !important;
    border: $border--solid-light;
    font-size: 14px;

    i {
      cursor: pointer;
      color: var(--color-text-secondary);
    }
  }
}
</style>
